import { Input } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

import './Input.scss'

export default function InputNormal({
  required = false,
  type = 'text',
  label,
  addonBefore,
  addonBeforeColor,
  prefix,
  suffix,
  min,
  max,
  flag,
  placeholder,
  disabled,
  name,
  value,
  onChange,
  error,
}) {
  return (
    <div className='normal-input'>
      {label && (
        <div className='d-flex align-items-center gap-2'>
          <label htmlFor={name}>
            {label} {required && <span className='text-danger'>*</span>}
          </label>
          {flag === 'it' ? <img src='/imgs/flags/italy.webp' alt='flag' /> : ''}
          {flag === 'es' ? <img src='/imgs/flags/spain.webp' alt='flag' /> : ''}
          {flag === 'eg' ? <img src='/imgs/flags/egypt.webp' alt='flag' /> : ''}
          {error && <InfoCircleOutlined className='text-danger fs-6 mb-2' />}
        </div>
      )}
      {type === 'password' ? (
        <Input.Password
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete='off'
        />
      ) : (
        <Input
          type={type}
          addonBefore={addonBefore}
          prefix={prefix}
          suffix={suffix}
          min={min}
          max={max}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          className={`${addonBefore ? `addonBefore ${addonBeforeColor}` : ''}`}
        />
      )}
      <small className='text-danger fs-12'>{error}</small>
    </div>
  )
}
